export default __webpack_public_path__ + "static/media/Inner Ardor.346349f7.png";